import { render, staticRenderFns } from "./internalExternalIssuesItemPop.vue?vue&type=template&id=50701cdc"
import script from "./internalExternalIssuesItemPop.vue?vue&type=script&lang=js"
export * from "./internalExternalIssuesItemPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50701cdc')) {
      api.createRecord('50701cdc', component.options)
    } else {
      api.reload('50701cdc', component.options)
    }
    module.hot.accept("./internalExternalIssuesItemPop.vue?vue&type=template&id=50701cdc", function () {
      api.rerender('50701cdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/iei/internalExternalIssuesItemPop.vue"
export default component.exports